"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    parcelImports: {
        path: "/settings/data/parcels"
    },
    parcelImportConfigCreate: {
        path: "/settings/data/parcels/:importTaskType"
    },
    parcelImportConfigEdit: {
        path: "/settings/data/parcels/:importTaskType/:importConfigurationId"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvcGFyY2VsSW1wb3J0cy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIHBhcmNlbEltcG9ydHM6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy9kYXRhL3BhcmNlbHNcIixcbiAgfSxcbiAgcGFyY2VsSW1wb3J0Q29uZmlnQ3JlYXRlOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvZGF0YS9wYXJjZWxzLzppbXBvcnRUYXNrVHlwZVwiLFxuICB9LFxuICBwYXJjZWxJbXBvcnRDb25maWdFZGl0OiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvZGF0YS9wYXJjZWxzLzppbXBvcnRUYXNrVHlwZS86aW1wb3J0Q29uZmlndXJhdGlvbklkXCIsXG4gIH0sXG59KTtcbiJdLCJuYW1lcyI6WyJyb3V0ZXMiLCJidWlsZFJvdXRlcyIsInBhcmNlbEltcG9ydHMiLCJwYXRoIiwicGFyY2VsSW1wb3J0Q29uZmlnQ3JlYXRlIiwicGFyY2VsSW1wb3J0Q29uZmlnRWRpdCJdLCJtYXBwaW5ncyI6Ijs7OzsrQkFFYUE7OztlQUFBQTs7O3VCQUZlO0FBRXJCLE1BQU1BLFNBQVNDLElBQUFBLGtCQUFXLEVBQUM7SUFDaENDLGVBQWU7UUFDYkMsTUFBTTtJQUNSO0lBQ0FDLDBCQUEwQjtRQUN4QkQsTUFBTTtJQUNSO0lBQ0FFLHdCQUF3QjtRQUN0QkYsTUFBTTtJQUNSO0FBQ0YifQ==